import React from "react";
// import useLodgeStore from "@/stores/lodge/lodgeStore";
import { BudgetComp, ToDoList } from "./RHCComponent";
import { ToDo, TripX } from "@/types/trip";
import useCurrencyStore from "@/stores/ui/currencyStore";

interface ExploreCardProps {
  selectedTrip: TripX | null;
}

const ExploreCard: React.FC<ExploreCardProps> = ({ selectedTrip }) => {
  const { selectedCurrency } = useCurrencyStore();
  // const tripTodos = useLodgeStore((state) => state.tripTodos);

  if (!selectedTrip) {
    return (
      <div className="h-full flex flex-col items-center justify-center space-y-4 p-8">
        <div className="text-6xl">🌎</div>
        <h3 className="text-xl font-semibold text-gray-800">
          No trip selected
        </h3>
      </div>
    );
  }

  // const todos = tripTodos[selectedTrip.id] || [];
  // const openTodos = todos.filter((todo: ToDo) => !todo.completed);

  return (
    <div className="h-[90%] overflow-hidden">
      <div className="flex flex-row space-x-4 h-full w-full">
        {/* Left Section - Budget */}
        <div className="h-full w-1/2 flex flex-col">
          {/* <div className="flex justify-between items-center mb-2">
            <h2 className="text-base h-8 flex justify-center items-center px-2 bg-indigo-100 w-20 text-indigo-700 rounded-md font-semibold">
              Budget
            </h2>
          </div> */}
          <BudgetComp trip={selectedTrip} key={selectedCurrency.code} />
        </div>

        {/* Right Section - ToDo */}
        <div className="h-full w-1/2 flex flex-col">
          {/* <div className="flex justify-between items-center mb-2">
            <h2 className="text-base h-8 flex justify-center items-center px-2 bg-indigo-100 w-16 text-indigo-700 rounded-md font-semibold">
              To Do
            </h2>
            <div className="flex items-center space-x-2">
              <div
                className={`w-2 h-2 ${
                  openTodos.length > 0 ? "bg-rose-500" : "bg-emerald-500"
                } rounded-full`}
              ></div>
              <span className="text-xs font-normal text-neutral-700 rounded-md">
                {openTodos.length} open
              </span>
            </div>
          </div> */}
          <ToDoList tripId={selectedTrip.id} />
        </div>
      </div>
    </div>
  );
};

export default ExploreCard;
